/* ================================================================
   REVOTION Systemkonfigurator — ENGINE (framework-frei, testbar)
   ----------------------------------------------------------------
   Reine Berechnungslogik: Auswahl (state) + Katalog (catalog) →
   Modulbedarf, Positionsliste mit Shopify-Variant-IDs, Summen.
   Kein DOM. UI und Tracking leben in konfigurator.js.

   Katalog kommt aus den Metaobjects (Section rendert JSON):
     catalog.products  { key → { id, title, img, variants:[{id,title,price,available,options:[]}] } }
     catalog.items     [ { id, bereich, label, sub, icon, cap, produkt, w_icon,
                           w_label, lottie, demo_wert, max_anzahl, sortierung,
                           info_titel, info_text, extra:{} } ]
   Preise sind CENTS (Shopify-Subunits).

   Preismodell-Entscheidungen (BRIEFING.md, 16.07.2026):
   - Integrationen = Bundle-Produkte (Connect + Kabel + ggf. CP+ CI enthalten),
     KEINE Komponenten-Rechnung mehr.
   - Truma-Regel: alle Items mit extra.gruppe === 'truma' teilen sich EIN
     Bundle (CP+ CI ist enthalten; Combi + Aventa zusammen ⇒ 1 Bundle).
   - Spannung: state.voltage '12v'|'24v' (Default 12v) wählt Varianten.
   ================================================================ */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.RevotionEngine = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  /* ── Texte (i18n) ──────────────────────────────────
     Der Rechenkern erzeugt auch Text — die Notizen der Belegzeilen. Vorgabe ist
     Deutsch; die UI reicht mit setTexts() die übersetzten `eng_*`-Schlüssel aus
     RV_KONFIG_I18N nach (Locale-Dateien `sections.konfigurator.eng_*`).
     Platzhalter in eckigen Klammern: tx('eng_modules', { n: 3 }).
     Produkt- und Markennamen (BRAIN, NODE, PANEL, TwoWay, Truma, Votronic …)
     bleiben in JEDER Sprache unverändert. */
  var TXT_DE = {
    eng_brain_note_full: 'LTE-M + GPS + WLAN + Bluetooth',
    eng_brain_note_lite: 'WLAN + Bluetooth',
    eng_brain_own_name: 'Vorhandenes BRAIN®',
    eng_brain_own_note: 'nicht im Preis',
    eng_custom_switch_sub: 'Eigene Funktion',
    eng_custom_lightswitch_sub: 'Eigenes Schalt-Licht',
    eng_custom_tank_sub: 'Eigener Tank',
    eng_custom_temp_sub: 'Eigener Sensor',
    eng_custom_twoway_sub: 'Eigene Bewegung',
    eng_twoway_open: 'Auf',
    eng_twoway_close: 'Zu',
    eng_covered_yadapter: 'per Y-Adapterstecker am CI-Bus',
    eng_covered_truma: 'im Truma-Bundle enthalten (CP+ CI)',
    eng_sold_out: 'Derzeit ausverkauft · wird nachgeliefert',
    eng_price_tbd: 'Preis folgt · wird nachgeliefert',
    eng_note_switch_single: '1 Kanal / Modul',
    eng_note_switch_multi: '5 Kanäle / Modul',
    eng_note_level: '2 Tanks / Modul',
    eng_note_temp: '2 Sensoren / Modul',
    eng_note_battery: '5 Kanäle à 60 A',
    eng_note_battery_hc: 'Hochstrom-Shunt 500 A',
    eng_note_battery_hc_causes: 'Hochstrom · [causes]',
    eng_cause_inverter: 'Wechselrichter',
    eng_cause_booster: 'Ladebooster ≥ 50 A',
    eng_module: 'Modul',
    eng_modules: '[n] Module',
    eng_needs_ambient: 'benötigt NODE® Ambient',
    eng_tablet_name: 'Eigenes Tablet verwenden',
    eng_tablet_note: 'kostenlos · bis zu 3 Endgeräte gleichzeitig',
    eng_panel_note: 'Fest verbautes Display',
    eng_votronic_name: 'Votronic Tankelektrode · [tank]',
    eng_votronic_note: '[len] · spannungsbasiert',
    eng_scale_name: 'SuperSense Scale X Pro · [tank]',
    eng_scale_note: 'Gaswaage · tauschbare 11-kg-Stahlflasche',
    eng_livello_name: 'Livello 0–90 Ω · [tank]',
    eng_livello_note: 'Füllstandssensor · wiederbefüllbare Alugas-Flasche · auf Anfrage',
    eng_fuel_name: 'Treibstoffsensor (0–190 Ω) · [tank]',
    eng_fuel_note: 'bauseits · nicht im Shop',
    eng_fuel_search: 'Treibstoffsensor 0-190 Ohm [tank]',
    eng_tempsensor_name: 'Temperatursensor digital · [len]',
    eng_tempsensor_note: '[n]× je Messpunkt',
    eng_led_name: 'LED-Strip COB [kind] · 5 m',
    eng_led_note: '[n]× 5 m',
    eng_led_rgbw: 'RGBW',
    eng_led_white: 'Weiß',
    eng_led_kww: 'Kalt-Warm-Weiß',
    eng_zone_one: '[label] · [n] Zone',
    eng_zone_many: '[label] · [n] Zonen'
  };
  var TXT = {};
  /* Übersetzungen setzen. Leere Werte und Shopifys „Translation missing …"
     werden verworfen — dann greift wieder Deutsch. */
  function setTexts(obj) {
    TXT = {};
    if (!obj) return;
    Object.keys(obj).forEach(function (k) {
      if (k.indexOf('eng_') !== 0) return;
      var v = obj[k];
      if (typeof v !== 'string' || !v || /^Translation missing/i.test(v)) return;
      TXT[k] = v;
    });
  }
  function tx(key, vars) {
    var s = TXT[key];
    if (s == null || s === '') s = TXT_DE[key];
    if (s == null) return key;
    if (vars) Object.keys(vars).forEach(function (k) {
      s = s.split('[' + k + ']').join(String(vars[k]));
    });
    return s;
  }

  /* ── State ──────────────────────────────────────────────────── */
  function initialState() {
    return {
      brainMode: 'lite',           // 'lite' | 'full' | 'own' (Kunde hat schon ein BRAIN)
      voltage: '12v',              // '12v' | '24v' — vorerst ohne UI-Frage
      sel: {},                     // { itemId: qty }
      ov: {},                      // { nodeKey: qtyOverride } — nur > Bedarf
      forceSingleSwitch: false,    // true = nur NODE Switch (einzeln), nie Switch Multi
      batBms: null,                // null | 'yes' | 'no'
      bmsBat: null,                // gewählte bms_batterie-Item-Id
      batMode: null,               // null | 'hc' | 'battery'
      boosterAmp: 0,               // Ladebooster-Ladestrom in A (≥50 → eigene High Current)
      thitronikProfinder: null,    // null | 'yes' | 'no' — hat der Kunde schon einen Thitronik ProFinder?
      panel: null,                 // null | '4' | '8'  (Upsell)
      install: null,               // null | 'self' | 'partner'
      custom: { schalter: [], lichter: [], tank: [], temp: [], bewegung: [] },
      tankCfg: {},                 // { tankId: { step, gasType } }
      tempSensorOv: null,
      led: { rgbw: 0, white: 0, kww: 0 },
      sensorOff: {}
    };
  }

  /* ── BRAIN-Modus ────────────────────────────────────────────────
     'own' = „Ich habe schon ein BRAIN" (Jasper, 13.10.2026): KEINE neue Zentrale
     in Warenkorb/Angebot/Summe, keine BRAIN-Einbauzeit. Ohne Nachfrage nach dem
     Modell gerechnet wie das große BRAIN — 30 NODEs, Nivellierung, LTE-Status. */
  function brainKey(state) {
    if (state.brainMode === 'own') return null;
    return state.brainMode === 'full' ? 'brain' : 'brain_lite';
  }
  // Fähigkeiten des großen BRAIN (Lagesensor, LTE-M, 30 NODEs)?
  function brainFull(state) {
    return state.brainMode === 'full' || state.brainMode === 'own';
  }
  function nodeLimit(state) {
    return brainFull(state) ? 30 : 10;
  }

  /* ── Katalog-Helfer ─────────────────────────────────────────── */
  function byBereich(catalog, bereich) {
    return (catalog.items || [])
      .filter(function (i) { return i.bereich === bereich; })
      .sort(function (a, b) { return (a.sortierung || 0) - (b.sortierung || 0); });
  }

  // Variante wählen: bevorzugte Options-Werte (z.B. ['24V'] oder ['30-110cm']),
  // Fallback erste Variante. Vergleich case-insensitiv, Teilstring erlaubt.
  function pickVariant(product, prefs) {
    if (!product || !product.variants || !product.variants.length) return null;
    var vs = product.variants;
    if (prefs && prefs.length) {
      for (var i = 0; i < vs.length; i++) {
        var hay = (vs[i].title + ' ' + (vs[i].options || []).join(' ')).toLowerCase();
        var all = prefs.every(function (p) { return hay.indexOf(String(p).toLowerCase()) !== -1; });
        if (all) return vs[i];
      }
    }
    return vs[0];
  }

  /* Größenspezifisches Panel-Bild: 4" = Panel Mini, 8" = Panel Maxi. Das Produktbild
     („Mockup_Panels") ist ein Sammelbild und sah in Leiste/Details/PDF wie das 4"-Panel
     aus — auch wenn 8" gewählt war (Jasper, 13.10.2026). Quelle IMMER der Katalog:
     Produktbild mit „Mini"/„Maxi" im Dateinamen, sonst ein eigenes Varianten-Bild.
     Nur sprechende Muster — KEINE nackten Ziffern: Shopify hängt Hash-Suffixe wie
     „_f30966f2-ce81-4215…" an. */
  function panelImg(product, size, variant) {
    if (!product) return null;
    var want = String(size) === '8' ? /maxi|panel[_-]?max(?![a-z])|8[ _-]?(zoll|inch)/i : /mini|panel[_-]?min(?![a-z])|4[ _-]?(zoll|inch)/i;
    var fileOf = function (u) { return String(u || '').split('?')[0].split('/').pop(); };
    var isCombined = function (u) { return /panels(?![a-z])/i.test(fileOf(u)); };   // „Mockup_Panels" = Sammelbild
    var imgs = (product.images || []).filter(function (u) { return want.test(fileOf(u)) && !isCombined(u); });
    if (imgs[0]) return imgs[0];
    if (variant && variant.img && !isCombined(variant.img) && variant.img !== product.img) return variant.img;
    return null;
  }

  /* Variante zuerst ueber die SKU waehlen. Optionswerte wie „Weiss" werden im Shop
     je Sprache uebersetzt, die SKU nicht — ohne diesen Weg griff im englischen Shop
     die Suche nach „Weiss" ins Leere und pickVariant fiel auf die ERSTE Variante
     (RGBW) zurueck: der Kunde bekam bunte statt weisser Strips in den Warenkorb
     (Befund 11.09.2026). Ohne SKU-Treffer gilt wieder der Optionswert. */
  function pickVariantBySku(product, sku, prefs) {
    if (product && product.variants && sku) {
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].sku || '') === String(sku)) return product.variants[i];
      }
    }
    return pickVariant(product, prefs);
  }

  // Wie pickVariant, aber ausverkaufte Varianten (available === false) werden
  // übersprungen — /cart/add.js lehnt sonst den GESAMTEN Warenkorb mit 422 ab.
  // Fehlt das available-Feld (älterer Katalog), gilt die Variante als kaufbar.
  function pickBuyableVariant(product, prefs) {
    var v = pickVariant(product, prefs);
    if (!v || v.available !== false) return v;
    var vs = product.variants;
    for (var i = 0; i < vs.length; i++) { if (vs[i].available !== false) return vs[i]; }
    return null;
  }

  function nodeVariant(catalog, state, key) {
    var p = catalog.products[key];
    if (!p) return null;
    // 12V/24V nur wählen, wenn das Produkt die Option überhaupt hat
    var v = pickVariant(p, [state.voltage === '24v' ? '24' : '12']);
    return v || pickVariant(p, []);
  }

  /* ── Auswahl-Helfer (wie Prototyp) ──────────────────────────── */
  function qty(state, id) { return state.sel[id] || 0; }
  function on(state, id) { return (state.sel[id] || 0) > 0; }

  function customAs(state, cat, defaults) {
    return (state.custom[cat] || []).map(function (c) {
      return Object.assign({ id: c.id, label: c.label, icon: c.icon + '.svg', custom: true }, defaults(c));
    });
  }
  function schalterAll(catalog, state) {
    return byBereich(catalog, 'schalter').concat(customAs(state, 'schalter', function (c) {
      return { sub: tx('eng_custom_switch_sub'), cap: 'switch', w_label: c.label, w_icon: c.icon };
    }));
  }
  function lichtSchalterAll(catalog, state) {
    return byBereich(catalog, 'lichtschalter').concat(customAs(state, 'lichter', function (c) {
      return { sub: tx('eng_custom_lightswitch_sub'), cap: 'lightswitch', w_label: c.label, w_icon: c.icon };
    }));
  }
  function tankAll(catalog, state) {
    return byBereich(catalog, 'tank').concat(customAs(state, 'tank', function (c) {
      return { sub: tx('eng_custom_tank_sub'), cap: 'level', w_label: c.label, demo_wert: 70 };
    }));
  }
  function tempAll(catalog, state) {
    return byBereich(catalog, 'temp').concat(customAs(state, 'temp', function (c) {
      return { sub: tx('eng_custom_temp_sub'), cap: 'temp', w_label: c.label, w_icon: c.icon, demo_wert: 20 };
    }));
  }
  function bewegungAll(catalog, state) {
    return byBereich(catalog, 'bewegung').concat(customAs(state, 'bewegung', function (c) {
      return { sub: tx('eng_custom_twoway_sub'), cap: 'twoway', w_label: c.label,
               extra: { twL: tx('eng_twoway_open'), twR: tx('eng_twoway_close') } };
    }));
  }

  function tankKind(t) {
    if (t.id === 'gas' || /gas/i.test(t.label)) return 'gas';
    if (t.id === 'diesel' || /treibstoff|diesel/i.test(t.label)) return 'fuel';
    return 'water';
  }
  /* sku = Artikelnummer der Shopify-Variante; sie bleibt in jeder Sprache gleich,
     der Optionswert („12-24cm") koennte uebersetzt werden. */
  var VOTRONIC_STEPS = [
    { label: '≤ 24 cm', len: '12-24', sku: '20001' },
    { label: '25–50 cm', len: '15-50', sku: '20002' },
    { label: '50–110 cm', len: '30-110', sku: '20003' }
  ];
  function tankStep(state, id) {
    var c = state.tankCfg[id];
    return (c && c.step != null) ? c.step : 1;
  }
  function gasType(state, id) {
    var c = state.tankCfg[id];
    // Standard bei Gas: KEIN Sensor gewählt. Optionen: 'livello' (wiederbefüllbare
    // Alugas-Flaschen), 'steel' (SuperSense Scale X für tauschbare 11-kg-Stahlflaschen).
    return (c && c.gasType) || 'none';
  }
  function sensorOn(state, id) { return !state.sensorOff[id]; }

  function tempCapCount(catalog, state) {
    return tempAll(catalog, state).filter(function (d) { return on(state, d.id); }).length;
  }
  function tempSensorQty(catalog, state) {
    var n = tempCapCount(catalog, state);
    return state.tempSensorOv == null ? n : Math.max(0, Math.min(n, state.tempSensorOv));
  }

  /* ── Integrations-Bundles (Gruppen-Regel + CI-Bus-Klima) ────── */
  // Liefert die tatsächlich zu kaufenden Bundles: je extra.gruppe nur EINS,
  // dedupliziert nach Produkt-Id. BMS-Batterien mit Produkt zählen wie eine
  // Integration.
  //
  // CI-Bus-Klima (Truma Aventa, extra.ciClimate): dockt an einen vorhandenen
  // CI-Bus-Host (Truma Combi oder Alde, extra.ciBus) per Y-Adapterstecker an —
  // dann KEIN eigenes Bundle (kein zweites CP+ CI, keine zweite Connect),
  // stattdessen 1× Y-Adapter (siehe buildLines). Ohne Host kauft die Klima ihr
  // eigenes Bundle (Truma-Bundle inkl. CP+ CI). Host-Wahl: bevorzugt gleiche
  // gruppe (Combi vor Alde), sonst niedrigste sortierung. Dometic-Klima hat
  // kein ciClimate-Flag → immer eigenständig (2 Widgets, 2 Bundles).
  function integrationBundles(catalog, state) {
    var chosen = byBereich(catalog, 'integration').filter(function (i) { return on(state, i.id); });
    if (state.batBms === 'yes' && state.bmsBat) {
      var b = byBereich(catalog, 'bms_batterie').find(function (x) { return x.id === state.bmsBat; });
      if (b && b.produkt && !(b.extra && b.extra.other)) chosen = chosen.concat([b]);
    }

    // CI-Klima ↔ Host-Paarung auflösen
    var merged = null;
    var climate = chosen.find(function (i) { return i.extra && i.extra.ciClimate; });
    if (climate) {
      var hosts = chosen.filter(function (i) { return i.extra && i.extra.ciBus; });
      if (hosts.length) {
        var host = hosts.find(function (h) { return h.extra.gruppe && climate.extra.gruppe === h.extra.gruppe; }) || hosts[0];
        merged = { climate: climate, host: host };
      }
    }

    var out = [], seenGroup = {}, seenProduct = {}, covered = [];
    chosen.forEach(function (i) {
      if (merged && i.id === merged.climate.id) { covered.push(Object.assign({ coveredBy: 'y_adapter', hostId: merged.host.id }, i)); return; }
      var grp = i.extra && i.extra.gruppe;
      var pid = i.produkt && i.produkt.id;
      if (grp && seenGroup[grp]) { covered.push(Object.assign({ coveredBy: 'gruppe' }, i)); return; }
      if (pid && seenProduct[pid]) { covered.push(Object.assign({ coveredBy: 'produkt' }, i)); return; }
      if (grp) seenGroup[grp] = true;
      if (pid) seenProduct[pid] = true;
      out.push(i);
    });
    return { bundles: out, covered: covered, all: chosen, merged: merged };
  }

  /* ── Kern: Modulbedarf ──────────────────────────────────────── */
  function packSwitch(catalog, state, c) {
    if (c <= 0) return { single: 0, multi: 0 };
    // Sonderauswahl: Kunde erzwingt einzelne NODE Switch (nie Switch Multi) —
    // sinnvoll bei verteilter Verbau-Situation.
    if (state.forceSingleSwitch) return { single: c, multi: 0 };
    var P1 = nodeVariant(catalog, state, 'switch_single').price;
    var P5 = nodeVariant(catalog, state, 'switch_multi').price;
    var best = { single: c, multi: 0 }, bestCost = P1 * c;
    for (var k = 1; k <= Math.ceil(c / 5); k++) {
      var rem = Math.max(0, c - 5 * k);
      var cost = P5 * k + P1 * rem;
      if (cost < bestCost) { bestCost = cost; best = { single: rem, multi: k }; }
    }
    return best;
  }

  function batteryPlan(catalog, state) {
    if (state.batBms === 'yes') {
      var b = byBereich(catalog, 'bms_batterie').find(function (x) { return x.id === state.bmsBat; });
      if (b && !(b.extra && b.extra.other)) return { kind: 'bms', bms: b, devices: [] };
      return { kind: null, bms: null, devices: [] };
    }
    if (state.batBms === 'no') {
      if (state.batMode === 'hc') return { kind: 'hc', bms: null, devices: [] };
      if (state.batMode === 'battery') {
        return {
          kind: 'battery', bms: null,
          devices: byBereich(catalog, 'energie_geraet').filter(function (d) { return on(state, d.id); })
        };
      }
    }
    return { kind: null, bms: null, devices: [] };
  }

  /* ── VE.Direct-Geräte (Victron, 27.08.2026) ─────────────────────
     Punkt-zu-Punkt-Schnittstelle: JEDES gewählte Gerät braucht sein eigenes
     VE-Direct-Bundle (NODE Connect + Adapterkabel) — deshalb Mengen statt
     Toggles (state.sel, max_anzahl im Metaobjekt) und KEINE Produkt-Dedupe
     wie bei den Marken-Bundles. Items: bereich 'vedirect'. */
  function vedirectDevices(catalog, state) {
    return byBereich(catalog, 'vedirect')
      .map(function (d) { return { item: d, qty: qty(state, d.id) }; })
      .filter(function (e) { return e.qty > 0; });
  }
  function vedirectCount(catalog, state) {
    return vedirectDevices(catalog, state).reduce(function (s, e) { return s + e.qty; }, 0);
  }

  function compute(catalog, state) {
    var ib = integrationBundles(catalog, state);
    var switchCh = 0;
    schalterAll(catalog, state).forEach(function (d) { switchCh += on(state, d.id) ? 1 : 0; });
    lichtSchalterAll(catalog, state).forEach(function (d) { switchCh += on(state, d.id) ? 1 : 0; });
    var rgbw = qty(state, 'rgbw'), white = qty(state, 'white');
    var tankN = tankAll(catalog, state).filter(function (d) { return on(state, d.id); }).length;
    var tempN = tempCapCount(catalog, state);
    var twoN = bewegungAll(catalog, state).filter(function (d) { return on(state, d.id); }).length;
    var plan = batteryPlan(catalog, state);
    var pack = packSwitch(catalog, state, switchCh);
    // High-Current-Module: 1× im reinen HC-Modus. In der Kanal-Übersicht bekommt
    // jeder Hochstrom-Verbraucher, der die 60 A/Kanal der NODE Battery sprengt,
    // ein eigenes High Current: der Wechselrichter (immer) und ein Ladebooster
    // ab 50 A (darunter reicht ein normaler NODE-Battery-Kanal).
    var hcCount = 0;
    if (plan.kind === 'hc') hcCount = 1;
    else if (plan.kind === 'battery') {
      if (on(state, 'endev_wr')) hcCount += 1;
      if (on(state, 'endev_booster') && (state.boosterAmp || 0) >= 50) hcCount += 1;
    }
    var req = {
      switch_single: pack.single, switch_multi: pack.multi,
      ambient: rgbw, ambient_mw: Math.ceil(white / 3),
      level: Math.ceil(tankN / 2), temp: Math.ceil(tempN / 2),
      twoway: twoN,
      battery: plan.kind === 'battery' ? 1 : 0,
      battery_hc: hcCount
    };
    return { integ: ib, req: req, switchCh: switchCh, plan: plan };
  }

  var MODULAR_KEYS = ['switch_single', 'switch_multi', 'ambient', 'ambient_mw', 'level', 'temp', 'twoway', 'battery', 'battery_hc'];

  function effQty(state, key, req) {
    var o = state.ov[key];
    return o != null ? Math.max(req, o) : req;
  }

  // Jedes Integrations-Bundle enthält 1 NODE Connect → zählt als 1 NODE
  // fürs BRAIN-Lite-Limit (max. 10).
  function totalNodes(catalog, state) {
    var c = compute(catalog, state);
    var t = c.integ.bundles.length;
    // Jedes VE.Direct-Gerät bringt seine eigene NODE Connect mit → zählt einzeln.
    t += vedirectCount(catalog, state);
    MODULAR_KEYS.forEach(function (k) { t += effQty(state, k, c.req[k] || 0); });
    return t;
  }

  /* ── Positionsliste (Warenkorb / Details / PDF) ─────────────── */
  /* ── Kampagnen-Rabatt (Streichpreis) ───────────────────────────────────
     Der Prozentsatz kommt aus Liquid: settings.campaign_* + Scope-Match,
     berechnet in snippets/revotion-campaign-percent.liquid und pro Katalog-
     Produkt als `disc` mitgeliefert (0 = kein Rabatt). Hier wird er auf die
     betroffenen Zeilen angewendet:
       l.total / l.unit  = EFFEKTIVER Preis (was der Kunde zahlt)
       l.listTotal / l.listUnit = Streichpreis
       l.discPercent     = Prozentsatz dieser Zeile
     Auf ganze Euro ABgerundet (Vorgabe Jasper 24.08.2026) — die Kasse
     rabattiert per automatischem Shopify-Rabatt centgenau, angezeigt wird
     also nie mehr als gezahlt wird. */
  function discountMap(catalog) {
    var map = {};
    function add(p) {
      if (!p || !p.disc) return;
      (p.variants || []).forEach(function (v) { map[v.id] = p.disc; });
    }
    var prods = catalog.products || {};
    Object.keys(prods).forEach(function (k) { add(prods[k]); });
    (catalog.items || []).forEach(function (it) { add(it.produkt); });
    return map;
  }

  /* Auf ganze Euro ABrunden.
     ── VORAUSSETZUNG, die erfüllt sein MUSS ────────────────────────────
     Die Shopify-Rabatte sind FESTBETRÄGE, die exakt dem abgerundeten
     Prozentwert entsprechen (BRAIN 599 € − 300 € = 299 €, BRAIN Lite
     299 € − 150 € = 149 €). Nur dann stimmt die Anzeige centgenau mit der
     Kasse überein.
     Würde jemand auf einen PROZENT-Rabatt zurückstellen, nähme die Kasse
     299,50 € während hier 299 € stünde — weniger anzeigen als kassiert
     wird, ist unzulässig. In dem Fall diese Funktion auf Math.ceil
     umstellen (Stand 24.08.2026, Entscheidung Jasper). */
  function discountCents(cents, pct) {
    return Math.floor(cents * (100 - pct) / 10000) * 100;
  }

  function applyCampaign(catalog, lines) {
    var map = discountMap(catalog);
    var savings = 0;
    lines.forEach(function (l) {
      var pct = l.variantId ? map[l.variantId] : 0;
      if (!pct || !l.total) return;
      l.listTotal = l.total;
      l.listUnit = l.unit;
      l.discPercent = pct;
      l.unit = discountCents(l.unit, pct);
      l.total = discountCents(l.total, pct);
      savings += l.listTotal - l.total;
    });
    return savings;
  }

  // Liefert { lines, total, listTotal, savings, itemCount, cartItems } — Preise in Cents.
  // cartItems = nur echte Shopify-Positionen { variantId, qty } (BRAIN zuerst).
  function buildLines(catalog, state) {
    var c = compute(catalog, state);
    var lines = [];

    function push(l) { lines.push(l); return l; }

    // BRAIN — beim vorhandenen BRAIN nur eine 0-€-Hinweiszeile (kein Produkt, kein
    // Warenkorb; `free` → im Angebot keine Position, wie das eigene Tablet)
    var bKey = brainKey(state);
    if (bKey) {
      var brainP = catalog.products[bKey];
      var brainV = pickVariant(brainP, []);
      push({
        key: bKey, name: brainP.title, img: brainP.img,
        note: tx(bKey === 'brain' ? 'eng_brain_note_full' : 'eng_brain_note_lite'),
        qty: 1, unit: brainV.price, total: brainV.price, variantId: brainV.id, fixed: true
      });
    } else {
      push({
        key: 'brain_own', name: tx('eng_brain_own_name'), note: tx('eng_brain_own_note'), img: null,
        qty: 1, unit: 0, total: 0, variantId: null, fixed: true, free: true
      });
    }

    // Integrations-Bundles (je Gruppe/Produkt nur eins). Mitbediente Marken („im Bundle
    // enthalten") und Zubehör stehen DIREKT unter ihrem Bundle — so, wie der Kunde denkt:
    // Truma Combi → Aventa (enthalten) → Y-Adapter; Thitronik → Thitronik-Y-Kabel.
    // (Bis 07.09.2026 hingen alle hinter dem LETZTEN Bundle — Prüfbericht S1.)
    var coveredDone = {};
    var pushCovered = function (cv) {
      coveredDone[cv.id] = true;
      push({
        key: 'integ0:' + cv.id, name: cv.label, img: cv.icon,
        note: tx(cv.coveredBy === 'y_adapter' ? 'eng_covered_yadapter' : 'eng_covered_truma'),
        qty: 1, unit: 0, total: 0, variantId: null, fixed: true, indent: true
      });
    };
    // Host eines mitbedienten Eintrags: CI-Klima → merged.host; gleiche Gruppe / gleiches
    // Produkt → das Bundle mit derselben Gruppe bzw. demselben Produkt.
    var hostOf = function (cv) {
      if (cv.hostId) return cv.hostId;
      var grp = cv.extra && cv.extra.gruppe, pid = cv.produkt && cv.produkt.id;
      var h = c.integ.bundles.find(function (b) {
        return (cv.coveredBy === 'gruppe' && grp && b.extra && b.extra.gruppe === grp) ||
               (cv.coveredBy === 'produkt' && pid && b.produkt && b.produkt.id === pid);
      });
      return h ? h.id : null;
    };
    var thiYDone = false;
    var pushThiY = function () {
      thiYDone = true;
      var tp = catalog.products.thi_y_adapter;
      var tv = tp ? pickBuyableVariant(tp, []) : null;
      push({
        key: 'acc:thiyadapter', name: tp ? tp.title : 'Thitronik Y-Adapterkabel 2in1',
        note: tv ? 'ProFinder ↔ NODE® Connect'
                 : tx(tp ? 'eng_sold_out' : 'eng_price_tbd'),
        img: tp ? tp.img : null,
        qty: 1, unit: tv ? tv.price : 0, total: tv ? tv.price : 0,
        variantId: tv ? tv.id : null, fixed: true, indent: true, onRequest: !tv
      });
    };
    c.integ.bundles.forEach(function (i) {
      var v = pickVariant(i.produkt, i.extra && i.extra.variante ? [i.extra.variante] : []);
      push({
        key: 'integ:' + i.id, name: i.produkt.title, img: i.produkt.img || i.icon,
        note: i.label, qty: 1, unit: v.price, total: v.price, variantId: v.id, fixed: true
      });
      c.integ.covered.forEach(function (cv) { if (!coveredDone[cv.id] && hostOf(cv) === i.id) pushCovered(cv); });

      // CI-Bus-Klima am Host: 1× Y-Adapterstecker statt zweitem Bundle.
      // Solange das Produkt nicht gelistet ist (konfigurator_produkt-Key
      // y_adapter fehlt), erscheint ein Platzhalter ohne Warenkorb-Position.
      if (c.integ.merged && c.integ.merged.host.id === i.id) {
        var yp = catalog.products.y_adapter;
        var yv = yp ? pickBuyableVariant(yp, []) : null;
        push({
          key: 'acc:yadapter', name: yp ? yp.title : 'Y-Adapterstecker',
          note: yv ? (c.integ.merged.climate.label + ' ↔ ' + c.integ.merged.host.label)
                   : tx(yp ? 'eng_sold_out' : 'eng_price_tbd'),
          img: yp ? yp.img : null,
          qty: 1, unit: yv ? yv.price : 0, total: yv ? yv.price : 0,
          variantId: yv ? yv.id : null, fixed: true, indent: true, onRequest: !yv
        });
      }
      // Thitronik ProFinder: hat der Kunde schon das GPS-Modul, belegt es an der
      // WiPro III denselben Port wie die NODE Connect → 1× Thitronik-Y-Kabel 2in1
      // splittet ihn. Nur wenn Thitronik gewählt UND ProFinder-Frage mit „ja".
      if (i.id === 'thitronik' && state.thitronikProfinder === 'yes') pushThiY();
    });
    // Sicherheitsnetz: Einträge ohne erkannten Host hinter den Bundles (kommt praktisch nicht vor)
    c.integ.covered.forEach(function (cv) { if (!coveredDone[cv.id]) pushCovered(cv); });
    if (!thiYDone && on(state, 'thitronik') && state.thitronikProfinder === 'yes') pushThiY();

    // VE.Direct: 1 Bundle JE Victron-Gerät (Punkt-zu-Punkt, keine Dedupe).
    // Alle Gerätetypen teilen sich dasselbe Bundle-Produkt → EINE Zeile mit
    // Menge = Gerätezahl; die Note listet die gewählten Geräteklassen.
    var vd = vedirectDevices(catalog, state);
    if (vd.length) {
      var vdP = null;
      vd.forEach(function (e) { if (!vdP && e.item.produkt) vdP = e.item.produkt; });
      var vdV = vdP ? pickBuyableVariant(vdP, []) : null;
      var vdN = vd.reduce(function (s, e) { return s + e.qty; }, 0);
      push({
        key: 'vedirect', name: vdP ? vdP.title : 'Victron Energy VE-Direct Integration',
        note: vd.map(function (e) { return (e.qty > 1 ? e.qty + '× ' : '') + e.item.label; }).join(' · '),
        img: vdP ? vdP.img : null,
        qty: vdN, unit: vdV ? vdV.price : 0, total: vdV ? vdV.price * vdN : 0,
        variantId: vdV ? vdV.id : null, fixed: true, onRequest: !vdV
      });
    }

    // NODEs (mit Mengen-Override, nur nach oben)
    var noteFor = {
      switch_single: tx('eng_note_switch_single'), switch_multi: tx('eng_note_switch_multi'),
      level: tx('eng_note_level'), temp: tx('eng_note_temp'), battery: tx('eng_note_battery'),
      battery_hc: (function () {
        if (state.batMode !== 'battery') return tx('eng_note_battery_hc');
        var causes = [];
        if (on(state, 'endev_wr')) causes.push(tx('eng_cause_inverter'));
        if (on(state, 'endev_booster') && (state.boosterAmp || 0) >= 50) causes.push(tx('eng_cause_booster'));
        return causes.length ? tx('eng_note_battery_hc_causes', { causes: causes.join(' + ') })
                             : tx('eng_note_battery_hc');
      })()
    };
    MODULAR_KEYS.forEach(function (k) {
      var r = c.req[k] || 0;
      var eff = effQty(state, k, r);
      if (eff <= 0) return;
      var p = catalog.products[k];
      var v = nodeVariant(catalog, state, k);
      push({
        key: k, name: p.title, img: p.img, note: noteFor[k] || (eff > 1 ? tx('eng_modules', { n: eff }) : tx('eng_module')),
        qty: eff, unit: v.price, total: v.price * eff, variantId: v.id,
        adjustable: true, minQty: r
      });

      // Zubehör eingerückt unter seiner NODE
      if (k === 'level') tankAccessories(catalog, state).forEach(push);
      if (k === 'temp') tempAccessories(catalog, state).forEach(push);
    });
    // LED-Strips einmalig hinter der letzten Ambient-Zeile einfügen
    // (bzw. ans Ende, wenn keine Ambient-NODE in der Liste ist)
    var leds = ledAccessories(catalog, state);
    if (leds.length) {
      var insAt = -1;
      lines.forEach(function (l, idx) { if (l.key === 'ambient' || l.key === 'ambient_mw') insAt = idx; });
      if (insAt >= 0) lines.splice.apply(lines, [insAt + 1, 0].concat(leds));
      else leds.forEach(function (l) {
        // Ohne Ambient-Modul gehören die Strips zu nichts → nicht einrücken (sonst
        // wirken sie als Zubehör der letzten NODE, z. B. TwoWay) und ehrlich anmerken.
        l.indent = false;
        l.needsAmbient = true;
        l.note = (l.note ? l.note + ' · ' : '') + tx('eng_needs_ambient');
        push(l);
      });
    }

    // PANEL-Upsell: '4' | '8' = festes Display; 'tablet' = eigenes Tablet nutzen
    // (kostenlos, kein Produkt — bis zu 3 Endgeräte gleichzeitig am BRAIN).
    if (state.panel === 'tablet') {
      push({
        key: 'panel', name: tx('eng_tablet_name'),
        note: tx('eng_tablet_note'), img: null,
        qty: 1, unit: 0, total: 0, variantId: null, fixed: true, free: true
      });
    } else if (state.panel) {
      var pp = catalog.products.panel;
      if (pp) {
        var pv = pickVariant(pp, [state.panel]);
        push({
          key: 'panel', name: pp.title + ' · ' + pv.title, img: panelImg(pp, state.panel, pv) || pp.img,
          note: tx('eng_panel_note'), qty: 1, unit: pv.price, total: pv.price, variantId: pv.id, fixed: true
        });
      }
    }

    // Vorbestellung: Flag vom Produkt (theme.preorder) ODER von der Variante —
    // beides steht im Katalog-JSON. Bewusst kein Selling Plan (Shopify-Bundles
    // vertragen keinen, Incident 02.09.2026): die UI zeigt den Hinweis an der
    // Zeile und hängt ihn als sichtbare Positionseigenschaft an den Warenkorb.
    var byVariant = {};
    function indexPreorder(pr) {
      if (!pr || !pr.variants) return;
      pr.variants.forEach(function (v) { if (v && v.id != null) byVariant[String(v.id)] = { product: pr, variant: v }; });
    }
    Object.keys(catalog.products || {}).forEach(function (k) { indexPreorder(catalog.products[k]); });
    (catalog.items || []).forEach(function (i) { if (i && i.produkt) indexPreorder(i.produkt); });
    lines.forEach(function (l) {
      var hit = l.variantId != null ? byVariant[String(l.variantId)] : null;
      var pre = !!(hit && (hit.product.preorder === true || hit.variant.preorder === true));
      l.preorder = pre;
      l.preorderNote = (pre && hit.product.preorder_note) ? String(hit.product.preorder_note) : null;
    });

    var savings = applyCampaign(catalog, lines);

    var total = 0, itemCount = 0;
    lines.forEach(function (l) {
      total += l.total;
      // Artikelzahl = kaufbare Positionen, wie sie im Warenkorb landen: keine
      // „im Bundle enthalten"-Zeilen, keine „auf Anfrage"/bauseits-Zeilen, kein eigenes Tablet.
      if (l.variantId && !l.noCart && String(l.key).indexOf('integ0:') !== 0) itemCount += l.qty;
    });
    var cartItems = lines
      .filter(function (l) { return l.variantId && l.total >= 0 && !l.noCart; })
      .map(function (l) { return { id: l.variantId, quantity: l.qty, preorder: !!l.preorder, preorderNote: l.preorderNote || null }; });

    return {
      lines: lines,
      total: total,                    // effektiv (nach Kampagnen-Rabatt)
      listTotal: total + savings,      // Streichpreis-Summe
      savings: savings,
      itemCount: itemCount,
      cartItems: cartItems,
      computed: c
    };
  }

  function tankAccessories(catalog, state) {
    var out = [];
    tankAll(catalog, state).forEach(function (t) {
      if (!on(state, t.id) || !sensorOn(state, t.id)) return;
      var kind = tankKind(t);
      if (kind === 'water') {
        var st = VOTRONIC_STEPS[tankStep(state, t.id)];
        var p = catalog.products.votronic;
        var v = p ? pickVariantBySku(p, st.sku, [st.len]) : null;
        out.push({
          key: 'acc:vot:' + t.id, name: tx('eng_votronic_name', { tank: t.label }),
          note: tx('eng_votronic_note', { len: v ? v.title : st.len + ' cm' }), img: t.icon,
          qty: 1, unit: v ? v.price : 0, total: v ? v.price : 0, variantId: v ? v.id : null,
          fixed: true, indent: true
        });
      } else if (kind === 'gas') {
        var gt = gasType(state, t.id);
        // Standard 'none' → gar kein Sensor. 'steel' → SuperSense Scale X (Gaswaage
        // für tauschbare 11-kg-Stahlflaschen). 'livello' → Livello (wiederbefüllbare
        // Alugas-Flaschen, auf Anfrage).
        if (gt === 'steel') {
          var g = catalog.products.scale_x;
          var gv = g ? pickVariant(g, []) : null;
          out.push({
            key: 'acc:gas:' + t.id, name: tx('eng_scale_name', { tank: t.label }),
            note: tx('eng_scale_note'), img: t.icon,
            qty: 1, unit: gv ? gv.price : 0, total: gv ? gv.price : 0, variantId: gv ? gv.id : null,
            fixed: true, indent: true
          });
        } else if (gt === 'livello') {
          out.push({
            key: 'acc:gas:' + t.id, name: tx('eng_livello_name', { tank: t.label }),
            note: tx('eng_livello_note'), img: t.icon,
            qty: 1, unit: 0, total: 0, variantId: null, fixed: true, indent: true, onRequest: true
          });
        }
        // gt === 'none' → keine Zeile
      } else {
        // Treibstoff: 0–190-Ω-Geber ist NICHT über den Shop wählbar → Hinweis mit
        // Google-Such-Link (UI rendert den Link, kein Produkt).
        out.push({
          key: 'acc:fuel:' + t.id, name: tx('eng_fuel_name', { tank: t.label }),
          note: tx('eng_fuel_note'), img: t.icon,
          searchLink: 'https://www.google.com/search?q=' + encodeURIComponent(tx('eng_fuel_search', { tank: t.label })),
          qty: 1, unit: 0, total: 0, variantId: null, fixed: true, indent: true, onRequest: true
        });
      }
    });
    return out;
  }

  function tempAccessories(catalog, state) {
    var n = tempSensorQty(catalog, state);
    if (n <= 0) return [];
    var p = catalog.products.temp_sensor;
    var v = p ? pickVariantBySku(p, '20051', ['3']) : null; // Default 3-m-Kabel
    return [{
      key: 'acc:tempsensor', name: tx('eng_tempsensor_name', { len: v ? v.title : '3 m' }),
      note: tx('eng_tempsensor_note', { n: n }), qty: n,
      unit: v ? v.price : 0, total: v ? v.price * n : 0, variantId: v ? v.id : null,
      img: (p && p.img) || null, imgHasBg: true,
      fixed: true, indent: true, adjustableAcc: true
    }];
  }

  function ledAccessories(catalog, state) {
    /* d[1] = Options-Wert der Shopify-Variante (immer deutsch, NICHT übersetzen),
       d[2] = i18n-Schlüssel für den angezeigten Namen. */
    var defs = [['rgbw', 'RGBW', 'eng_led_rgbw', '22001'], ['white', 'Weiß', 'eng_led_white', '22002'],
                ['kww', 'Kalt-Warm-Weiß', 'eng_led_kww', '22003']];
    var p = catalog.products.led_strip;
    var out = [];
    defs.forEach(function (d) {
      var n = state.led[d[0]] || 0;
      if (n <= 0 || !p) return;
      var v = pickVariantBySku(p, d[3], [d[1]]);
      out.push({
        key: 'acc:led:' + d[0], name: tx('eng_led_name', { kind: tx(d[2]) }),
        note: tx('eng_led_note', { n: n }), qty: n, unit: v.price, total: v.price * n, variantId: v.id,
        img: v.img || p.img || null, imgHasBg: true,
        fixed: true, indent: true
      });
    });
    return out;
  }

  /* ── Modul-Gruppierung für den PDF-Beleg ───────────────────────
     Liefert die Positionsliste (wie buildLines), aber jede NODE-Zeile mit
     `caps` angereichert: welche Funktionen (Cap-Ebene, mit Label + Icon)
     diese Node übernimmt. Damit baut das PDF eine 3-Spalten-Ansicht:
     Node (Bild+Name) · Funktionen (Icons+Labels) · Preis.
     Verteilungsregeln:
       switch_multi → je 5 Schaltkanäle, switch_single → je 1 (in Reihenfolge)
       level → je 2 Tanks, temp → je 2 Messpunkte, twoway → je 1 Antrieb
       ambient/ambient_mw → die Lichtzonen-Zähler
       integ:<id> → die Integration selbst + evtl. per Y-Adapter/CI-Bus
                    mitbediente Marken (covered)
     Zubehör-Zeilen (acc:*) und „im Bundle enthalten" (integ0:*) bleiben
     caps-los (sie sind Unterpositionen ihrer Node). ── */
  function capOf(item) {
    return { label: item.w_label || item.label, icon: item.w_icon || item.icon || null };
  }
  function nodeGroups(catalog, state) {
    var built = buildLines(catalog, state);
    var c = built.computed;
    var onf = function (d) { return on(state, d.id); };
    var switchCaps = schalterAll(catalog, state).filter(onf)
      .concat(lichtSchalterAll(catalog, state).filter(onf)).map(capOf);
    var tankCaps = tankAll(catalog, state).filter(onf).map(capOf);
    var tempCaps = tempAll(catalog, state).filter(onf).map(capOf);
    var twCaps = bewegungAll(catalog, state).filter(onf).map(capOf);
    var lichtItems = byBereich(catalog, 'licht');
    function lichtCap(id) {
      var n = qty(state, id); if (n <= 0) return null;
      var it = null; lichtItems.forEach(function (i) { if (i.id === id || i.item_id === id) it = i; });
      return { label: tx(n === 1 ? 'eng_zone_one' : 'eng_zone_many', { label: (it && it.label) || id, n: n }),
               icon: (it && it.icon) || null };
    }
    var cur = { sw: 0, tank: 0, temp: 0, tw: 0 };

    return built.lines.map(function (l) {
      var k = String(l.key), caps = [];
      if (k === 'switch_single') { caps = switchCaps.slice(cur.sw, cur.sw + l.qty); cur.sw += l.qty; }
      else if (k === 'switch_multi') { caps = switchCaps.slice(cur.sw, cur.sw + l.qty * 5); cur.sw += l.qty * 5; }
      else if (k === 'ambient') { var ca = lichtCap('rgbw'); if (ca) caps = [ca]; }
      else if (k === 'ambient_mw') { var cw = lichtCap('white'); if (cw) caps = [cw]; }
      else if (k === 'level') { caps = tankCaps.slice(cur.tank, cur.tank + l.qty * 2); cur.tank += l.qty * 2; }
      else if (k === 'temp') { caps = tempCaps.slice(cur.temp, cur.temp + l.qty * 2); cur.temp += l.qty * 2; }
      else if (k === 'twoway') { caps = twCaps.slice(cur.tw, cur.tw + l.qty); cur.tw += l.qty; }
      else if (k === 'vedirect') {
        vedirectDevices(catalog, state).forEach(function (e) {
          for (var vi = 0; vi < e.qty; vi++) caps.push(capOf(e.item));
        });
      }
      else if (k.indexOf('integ:') === 0) {
        var ig = null; c.integ.bundles.forEach(function (b) { if ('integ:' + b.id === k) ig = b; });
        if (ig) {
          caps.push(capOf(ig));
          c.integ.covered.forEach(function (cv) {
            var sameHost = cv.hostId && cv.hostId === ig.id;
            var sameGrp = ig.extra && ig.extra.gruppe && cv.extra && cv.extra.gruppe === ig.extra.gruppe;
            if (sameHost || sameGrp) caps.push(capOf(cv));
          });
        }
      }
      return {
        key: l.key, name: l.name, img: l.img, imgHasBg: l.imgHasBg, note: l.note,
        qty: l.qty, unit: l.unit, total: l.total, onRequest: l.onRequest,
        // Kampagnen-Felder durchreichen, sonst fehlt der Streichpreis in der
        // Übergabe-/Druckansicht (die rendert aus nodeGroups, nicht buildLines)
        listTotal: l.listTotal, listUnit: l.listUnit, discPercent: l.discPercent,
        indent: l.indent, caps: caps
      };
    });
  }


  /* ── Einbau-Kostenvoranschlag („Was kostet ein Einbau?") ─────────────
     Werkstattzeit in MINUTEN: je Modul aus konfigurator_produkt.einbauzeit_min, je
     gewählter Funktion/Integration aus konfigurator_item.einbauzeit_min. Fehlt ein Wert
     im Katalog, greift INSTALL_DEFAULTS (Produkt-Key bzw. Bereich). Die Einzelzeiten
     werden NIE angezeigt — nur der Rahmen aus installEstimate() (Jasper, 10.09.2026). */
  // Werte von Jasper (Werkstatt-Erfahrung, 10.09.2026) — die Metaobjekte tragen dieselben Zahlen,
  // hier nur als Netz, falls ein Feld im Admin leer bleibt.
  var INSTALL_DEFAULTS = {
    products: { brain: 60, brain_lite: 45, connect: 15, switch_single: 20, switch_multi: 35, ambient: 20, ambient_mw: 35,
                level: 25, temp: 20, twoway: 25, battery: 60, battery_hc: 45, temp_sensor: 5, votronic: 15, scale_x: 15,
                led_strip: 10, panel: 15, y_adapter: 5, thi_y_adapter: 5 },
    bereich:  { schalter: 20, lichtschalter: 20, licht: 20, tank: 15, temp: 15, bewegung: 20, integration: 10,
                bms_batterie: 5, vedirect: 10, energie_geraet: 15, upsell: 0 },
    custom:   { schalter: 20, lichter: 25, tank: 25, temp: 15, bewegung: 40 }
  };
  function minOf(v, dflt) {
    var n = parseInt(v, 10);
    return isFinite(n) && n >= 0 ? n : (dflt || 0);
  }
  function productMinutes(catalog, key) {
    var p = catalog.products[key];
    return minOf(p && p.einbauzeit_min, INSTALL_DEFAULTS.products[key]);
  }
  function itemMinutes(item) {
    if (!item) return 0;
    return minOf(item.einbauzeit_min, INSTALL_DEFAULTS.bereich[item.bereich]);
  }

  // Liefert { minutes, parts: [{ key, qty, min }] } — parts nur für Tests/Diagnose.
  function installMinutes(catalog, state) {
    var c = compute(catalog, state);
    var parts = [];
    var total = 0;
    function add(key, qty, min) {
      if (!qty || !min) return;
      parts.push({ key: key, qty: qty, min: min });
      total += qty * min;
    }
    var byId = {};
    (catalog.items || []).forEach(function (i) { if (i && i.id) byId[i.id] = i; });

    // Grundinstallation = BRAIN (Montage, Versorgung, Inbetriebnahme, App-Kopplung) —
    // entfällt beim vorhandenen BRAIN
    var bk = brainKey(state);
    if (bk) add(bk, 1, productMinutes(catalog, bk));

    // Integrationen: Zeit je Bundle (inkl. NODE Connect + Kabel); mitbediente Marken
    // und Y-Adapter zählen mit ihrer eigenen Zeit
    c.integ.bundles.forEach(function (i) { add('integ:' + i.id, 1, itemMinutes(i)); });
    c.integ.covered.forEach(function (i) { add('integ0:' + i.id, 1, itemMinutes(i)); });
    if (c.integ.merged) add('acc:yadapter', 1, productMinutes(catalog, 'y_adapter'));
    if (on(state, 'thitronik') && state.thitronikProfinder === 'yes') add('acc:thiyadapter', 1, productMinutes(catalog, 'thi_y_adapter'));
    vedirectDevices(catalog, state).forEach(function (e) { add('ved:' + e.item.id, e.qty, itemMinutes(e.item)); });

    // NODE-Module (inkl. Mengen-Override)
    MODULAR_KEYS.forEach(function (k) {
      var q = effQty(state, k, c.req[k] || 0);
      if (q > 0) add(k, q, productMinutes(catalog, k));
    });

    // Gewählte Funktionen: Verbraucher/Licht/Tank/Temperatur/Bewegung an ihre Kanäle
    var funcBereiche = { schalter: 1, lichtschalter: 1, licht: 1, tank: 1, temp: 1, bewegung: 1 };
    Object.keys(state.sel || {}).forEach(function (id) {
      var q = state.sel[id];
      if (!q) return;
      var it = byId[id];
      if (it) {
        if (funcBereiche[it.bereich]) add('item:' + id, q, itemMinutes(it));
        else if (it.bereich === 'energie_geraet' && c.plan.kind === 'battery') add('item:' + id, q, itemMinutes(it));
        return;
      }
      // Eigene Verbraucher (cust_<kategorie>_<n>) → Standard je Kategorie
      var m = /^cust_(schalter|lichter|tank|temp|bewegung)_/.exec(id);
      if (m) add('item:' + id, q, INSTALL_DEFAULTS.custom[m[1]]);
    });

    // Zubehör
    tankAll(catalog, state).forEach(function (t) {
      if (!on(state, t.id) || !sensorOn(state, t.id)) return;
      var kind = tankKind(t);
      if (kind === 'water') add('acc:vot:' + t.id, 1, productMinutes(catalog, 'votronic'));
      else if (kind === 'gas' && gasType(state, t.id) === 'steel') add('acc:gas:' + t.id, 1, productMinutes(catalog, 'scale_x'));
    });
    var tsN = tempSensorQty(catalog, state);
    if (tsN > 0) add('acc:tempsensor', tsN, productMinutes(catalog, 'temp_sensor'));
    var leds = (state.led && ((state.led.rgbw || 0) + (state.led.white || 0) + (state.led.kww || 0))) || 0;
    if (leds > 0) add('acc:led', leds, productMinutes(catalog, 'led_strip'));
    if (state.panel === '4' || state.panel === '8') add('panel', 1, productMinutes(catalog, 'panel'));

    return { minutes: total, parts: parts };
  }

  // opts: { rate (€/h, brutto), spread (€ Breite des Von-bis-Rahmens), step (€ Rundung), factor }
  function installEstimate(catalog, state, opts) {
    opts = opts || {};
    var m = installMinutes(catalog, state);
    var factor = (isFinite(opts.factor) && opts.factor > 0) ? opts.factor : 1;
    var minutes = Math.round(m.minutes * factor);
    var rate = (isFinite(opts.rate) && opts.rate > 0) ? opts.rate : 150;
    var spread = (opts.spread != null && isFinite(opts.spread) && opts.spread >= 0) ? opts.spread : 200;
    var step = (isFinite(opts.step) && opts.step > 0) ? opts.step : 10;
    var cost = minutes / 60 * rate;
    var from = Math.max(0, Math.floor((cost - spread / 2) / step) * step);
    var to = Math.max(from, Math.ceil((cost + spread / 2) / step) * step);
    return {
      minutes: minutes,
      hours: Math.round(minutes / 6) / 10,     // eine Nachkommastelle
      rate: rate,
      cost: Math.round(cost),
      from: from,
      to: to,
      spread: spread,
      parts: m.parts
    };
  }

  /* ── Konfigurations-Code (wie Prototyp, + voltage/panel) ────── */
  function code(state) {
    try {
      // ALLES, was Positionen oder den gespeicherten Stand beeinflusst — sonst erkennt
      // der Konfigurator eine Änderung nicht als „seit dem Speichern geändert" (LED-Mengen,
      // Tank-/Sensor-Einstellungen, Batteriemarke und Einbauart fehlten bis 07.09.2026).
      var str = JSON.stringify({
        b: state.brainMode, v: state.voltage, s: state.sel, o: state.ov,
        p: state.panel, c: state.custom, bb: state.batBms, bs: state.bmsBat, bm: state.batMode,
        tp: state.thitronikProfinder, fs: state.forceSingleSwitch, ba: state.boosterAmp,
        l: state.led, tc: state.tankCfg, so: state.sensorOff, to: state.tempSensorOv, i: state.install
      });
      var h = 0;
      for (var i = 0; i < str.length; i++) { h = (h * 31 + str.charCodeAt(i)) >>> 0; }
      return 'RVT-' + h.toString(36).toUpperCase().padStart(6, '0').slice(0, 6);
    } catch (e) { return 'RVT-000000'; }
  }

  return {
    setTexts: setTexts,
    tx: tx,
    TXT_DE: TXT_DE,
    initialState: initialState,
    brainKey: brainKey,
    brainFull: brainFull,
    nodeLimit: nodeLimit,
    byBereich: byBereich,
    pickVariant: pickVariant,
    panelImg: panelImg,
    pickVariantBySku: pickVariantBySku,
    schalterAll: schalterAll,
    lichtSchalterAll: lichtSchalterAll,
    tankAll: tankAll,
    tempAll: tempAll,
    bewegungAll: bewegungAll,
    tankKind: tankKind,
    tankStep: tankStep,
    gasType: gasType,
    sensorOn: sensorOn,
    tempCapCount: tempCapCount,
    tempSensorQty: tempSensorQty,
    integrationBundles: integrationBundles,
    vedirectDevices: vedirectDevices,
    vedirectCount: vedirectCount,
    packSwitch: packSwitch,
    batteryPlan: batteryPlan,
    compute: compute,
    effQty: effQty,
    totalNodes: totalNodes,
    discountCents: discountCents,
    buildLines: buildLines,
    nodeGroups: nodeGroups,
    code: code,
    installMinutes: installMinutes,
    installEstimate: installEstimate,
    INSTALL_DEFAULTS: INSTALL_DEFAULTS,
    VOTRONIC_STEPS: VOTRONIC_STEPS,
    MODULAR_KEYS: MODULAR_KEYS
  };
});
